import React from 'react';
import { GenericModal } from '../../GenericModal/index.js';
import { i18n } from '../../../i18n/translate.js';
import { sanitizeUrl } from '@braintree/sanitize-url';
import { ProgressSpinner } from '../../progress-spinner/component.js';

var ChartExportModal = function ChartExportModal(props) {
  var downloadUrl = props.downloadUrl,
      onClose = props.onClose,
      onDownloadClicked = props.onDownloadClicked,
      show = props.show,
      title = props.title;
  var ready = !!downloadUrl;
  return /*#__PURE__*/React.createElement(GenericModal, {
    size: "md",
    show: show,
    onClose: onClose,
    title: title,
    canClose: true,
    footerCloseButton: {
      text: i18n.t('Close'),
      variant: 'neutral'
    }
  }, ready ? /*#__PURE__*/React.createElement("div", null, i18n.t('Your report is ready and available for download '), /*#__PURE__*/React.createElement("a", {
    download: true,
    href: sanitizeUrl(downloadUrl),
    onClick: onDownloadClicked
  }, i18n.t('here.'))) : /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(ProgressSpinner, {
    size: "lg"
  }), /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("p", null, i18n.t('This may take a little while. If you would like to wait for a link, please leave this modal open.')), /*#__PURE__*/React.createElement("p", null, i18n.t('If you close the modal, we will email you when the file is ready.')))));
};

ChartExportModal.displayName = "ChartExportModal";
export { ChartExportModal };